var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSchoolIcon = function SvgSchoolIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "schoolIcon_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 65.2 65.2"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".schoolIcon_svg__cls-1{fill:none;stroke:#12263f;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.21 36.78a2.7 2.7 0 0 1-1.3-.4L15 27.07a1.64 1.64 0 0 1-.54-1.19 1.76 1.76 0 0 1 .5-1.26l.42-.27 15.53-9.83a2.3 2.3 0 0 1 1.16-.44h.06a2.5 2.5 0 0 1 1.16.44l16 10.1a1.76 1.76 0 0 1 .5 1.26 1.64 1.64 0 0 1-.54 1.19l-15.96 9.31a3 3 0 0 1-1.3.4",
    className: "schoolIcon_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.69 31.69-.11 8.94a1.9 1.9 0 0 0 .21 1.07 2.05 2.05 0 0 0 .89.66l10.1 4.71a2.9 2.9 0 0 0 2.45 0l10.22-4.8a2 2 0 0 0 .9-.66v-.05a2 2 0 0 0 .21-1.07l-.07-8.94",
    className: "schoolIcon_svg__cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m49.74 25.76-.01 11.66",
    style: {
      fill: "none",
      stroke: "#12263f",
      strokeLinejoin: "round",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.74 34.13-.01 4.78",
    style: {
      fill: "none",
      stroke: "#12263f",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }));
};
export default SvgSchoolIcon;